"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hydroWallet_1 = __importDefault(require("./hydroWallet"));

exports.HydroWallet = hydroWallet_1.default;

var extensionWallet_1 = __importDefault(require("./extensionWallet"));

exports.ExtensionWallet = extensionWallet_1.default;

var imtoken_1 = __importDefault(require("./imtoken"));

exports.ImToken = imtoken_1.default;

var baseWallet_1 = __importDefault(require("./baseWallet"));

exports.BaseWallet = baseWallet_1.default;

var WalletConnectWallet_1 = __importDefault(require("./WalletConnectWallet"));

exports.WalletConnectWallet = WalletConnectWallet_1.default;

var ledger_1 = __importDefault(require("./ledger"));

exports.Ledger = ledger_1.default;

var request_1 = __importDefault(require("request"));

var utils_1 = require("ethers/utils");

var ethers_1 = require("ethers");

var providers_1 = require("ethers/providers");

var NeedUnlockWalletError = baseWallet_1.default.NeedUnlockWalletError,
    NotSupportedError = baseWallet_1.default.NotSupportedError;
exports.NeedUnlockWalletError = NeedUnlockWalletError;
exports.NotSupportedError = NotSupportedError;
var globalNodeUrl = "https://ropsten.infura.io";

exports.payloadId = function () {
  var datePart = new Date().getTime() * Math.pow(10, 3);
  var extraPart = Math.floor(Math.random() * Math.pow(10, 3));
  var id = datePart + extraPart;
  return id;
};

exports.setGlobalNodeUrl = function (nodeUrl) {
  if (nodeUrl) {
    globalNodeUrl = nodeUrl;
  }
};

exports.truncateAddress = function (address) {
  return address.slice(0, 6) + "..." + address.slice(-4);
};

exports.getNetworkID = function () {
  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"net_version\",\"params\":[],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);
          resolve(parseInt(json.result, 10));
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.sendRawTransaction = function (data) {
  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"eth_sendRawTransaction\",\"params\":[\"" + data + "\"],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);

          if (json.result) {
            resolve(json.result);
          } else if (json.error) {
            reject(json.error);
          } else {
            reject(new Error("Unknown Error"));
          }
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.getBalance = function (address) {
  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"eth_getBalance\",\"params\":[\"" + address + "\", \"latest\"],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);
          resolve(new utils_1.BigNumber(json.result));
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.getTransactionReceipt = function (txID) {
  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"eth_getTransactionReceipt\",\"params\":[\"" + txID + "\"],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);
          resolve(json.result);
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.getEstimateGas = function (params) {
  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"eth_estimateGas\",\"params\":[" + JSON.stringify(params) + "],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);
          resolve(json.result);
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.getTransactionCount = function (address, status) {
  if (status === void 0) {
    status = "latest";
  }

  return new Promise(function (resolve, reject) {
    request_1.default.post(globalNodeUrl, {
      headers: {
        "content-type": "application/json"
      },
      form: "{\"jsonrpc\":\"2.0\",\"method\":\"eth_getTransactionCount\",\"params\":[\"" + address + "\",\"" + status + "\"],\"id\":" + exports.payloadId() + "}"
    }, function (error, response, data) {
      if (error) {
        reject(error);
      }

      try {
        if (data) {
          var json = JSON.parse(data);
          resolve(Number(json.result));
        }
      } catch (e) {
        reject(e);
      }
    });
  });
};

exports.getContract = function (contractAddress, abi) {
  var provider = new providers_1.JsonRpcProvider(globalNodeUrl);
  return new ethers_1.Contract(contractAddress, abi, provider);
};

exports.defaultWalletTypes = [extensionWallet_1.default.TYPE, hydroWallet_1.default.TYPE, WalletConnectWallet_1.default.TYPE, ledger_1.default.TYPE];